import React, { Component, Fragment } from 'react';
import {
	Layout,
	Collapse,
	Tag,
	Badge,
	Icon,
	Row,
	Col,
	Card,
	message,
	Spin,
	Modal,
	Carousel,
	Button,
	Popover,
	List,
	Typography,
} from 'antd';
import { WordInfo, LiteracyInfo, DistinctInfo } from './informations';
import { SpellsSetup, SynoSetup, HanjaSetup, DialectSetup, MultiLangSetup } from './setups';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as services from 'services';
import * as actions from 'actions';

import Advance from './advance';
import './RightMenu.css';
import helperCate from './HelperCate.json';
var nlp = require('compromise');

const { Content } = Layout;
const Panel = Collapse.Panel;

const customPanelStyle = {
	selected: {
		borderRadius: 4,
		marginLeft: 5,
		marginRight: 5,
		marginBottom: 5,
		padding: '0!important',
		border: '1px solid #596674',
		overflow: 'hidden',
	},
	unselected: {
		borderRadius: 4,
		marginLeft: 5,
		marginRight: 5,
		marginBottom: 5,
		padding: '0!important',
		border: '1px solid #e8e8e8',
		overflow: 'hidden',
	},
};
const mapStateToProps = state => ({
	lqInfosText: state.info.lqInfosText,
	blockKeys: state.blocks.blockKeys,
	blockTexts: state.blocks.blockTexts,
	flag: state.blocks.flag,
	disableItems: state.spell.disableItems,
	selectMenu: state.menu.selectMenu,
	filters: state.syno.filters,
	dialectFilters: state.dialect.dialectFilters,
	spellChecked: state.checked.spellChecked,
	synoChecked: state.checked.synoChecked,
	dialectChecked: state.checked.dialectChecked,
	lqChecked: state.checked.lqChecked,
	user: state.auth.user,
	authenticated: state.auth.authenticated,
	//multioptions: state.multilang.multioptions,
	//type: state.blocks.type,
});

const info = () => {
	message.info('서비스 준비 중입니다.');
};

const data = [
	{ range: '1 (1320~1850)', text: '법조문이나 전문서적에 포함되는 글의 평균 수준' },
	{ range: '2 (1120~1450)', text: '신문 사설이나 대입 논술고사 지문에 포함되는 글의 평균 수준' },
	{ range: '3 (910~1190)', text: '고등학교 1~3학년 교과서에 포함되는 글의 평균 수준' },
	{ range: '4 (720~1000)', text: '초등학교 6~중학교 3학년 교과서에 포함되는 글의 평균 수준' },
	{ range: '5 (560~840)', text: '초등학교 3~5학년 교과서에 포함되는 글의 평균 수준' },
	{ range: '6 (350~630)', text: '초등학교 1~2학년 교과서에 포함되는 글의 평균 수준' },
	{ range: '7 (100~480)', text: '어린이 동화책에 포함되는 글의 평균 수준' },
];

const content = (
	<div>
		<p>
			글은 사용된 어휘들이 어렵고 문장 길이가 길수록 이해하기가 어려워집니다. <br />
			문서의 난이도는 이러한 이치를 바탕으로 과학적인 검증과정을 거쳐 결정되었습니다.
			<br /> 일반적으로 긴 문장은 정확하게 분석되나 500어절보다 짧은 글은 어휘의 난이도를 반영하는 통계 <br />
			수치의 왜곡으로 인하여 문장의 난이도가 예상과 다르게 높거나 낮게 보일 수 있습니다.
		</p>
		<p>문장분석기의 난이도는 다음의 지수 범위를 기준으로 설계되었습니다.</p>
		<List
			bordered={false}
			dataSource={data}
			renderItem={item => (
				<List.Item>
					<Typography.Text style={{ width: '120px', color: '#1E88E5', fontWeight: 500 }}>
						{item.range}
					</Typography.Text>{' '}
					{item.text}
				</List.Item>
			)}
		/>
	</div>
);

const content_spell = (
	<div style={{ width: '350px' }}>
		<p>
			한국어 어문 규정(한글 맞춤법, 표준어 규정, 외래어 표기법)에 따른 검사 결과입니다.
			<br /> 철자 오류, 어휘선택 오류 등과 같이 일반적인 문서작성 프로그램에서는 제공하지 않는 맞춤법 검사 결과를
			확인할 수 있습니다. 일부 결과는 부정확할 수 있으니 이 경우는 무시하거나 오류 신고를 하시면 프로그램의 기능
			향상에 도움이 됩니다.
		</p>
	</div>
);

const content_grammar = (
	<div style={{ width: '350px' }}>
		<p>
			어휘의 선택과 표현, 품사의 사용, 문장 성분의 호응과 같은 문법/어법과 관련된 검사 기능이 추가될 예정입니다.
		</p>
	</div>
);

const content_syn = (
	<div style={{ width: '350px' }}>
		<p>
			글을 쓰면서 유의어를 활용하면 풍부한 어휘를 구사할 수 있습니다.
			<br /> 쉽게 쓸 것인지 아니면 어렵게 쓸 것인지, 학술적인 표현을 할 것인지 아니면 일상적인 표현을 할 것인지의
			목표를 정하면 원하는 목적의 세련된 어휘를 사용할 수 있도록 도와 드립니다.
		</p>
	</div>
);

const content_distinct = (
	<div style={{ width: '350px' }}>
		<p>
			중복된 표현이 자주 나오면 글의 집중도가 떨어지기 때문에 가능한 한 피하는 것이 좋습니다. <br />
			중복 표현 목록을 살펴보고 간결하면서도 다채로운 표현의 글로 수정해 보세요.
		</p>
	</div>
);

const content_word = (
	<div style={{ width: '350px' }}>
		<p>
			중요한 품사별로 정리된 다빈도 어휘 목록을 살펴볼 수 있습니다.
			<br /> 통계를 살펴보고 문장 중에 더욱 전달하고 싶거나 강조하고 싶은 부분을 확인할 때 도움이 되는 기능입니다.
		</p>
	</div>
);

const content_hanja = (
	<div style={{ width: '350px' }}>
		<p>
			한국어에서 한자어(漢字語)는 고유어보다 더 큰 비중을 차지하는 어휘입니다. <br />
			한자어는 한글로도 표기할 수 있으나 정확한 의미의 전달이나 확인을 위해서는 한자(漢字)를 알아야 할 경우가
			있습니다.
		</p>
	</div>
);

const content_dialect = (
	<div style={{ width: '350px' }}>
		<p>
			방언은 고유한 가치를 지니는 우리의 소중한 언어 자산입니다.
			<br /> 8도 및 제주도의 방언을 적절히 활용하면 우리말의 지평을 넓힐 수 있습니다.
		</p>
	</div>
);

const content_multi = (
	<div style={{ width: '350px' }}>
		<p>
			한국어를 11개의 다국어로 살펴볼 수 있습니다. <br />
			한국어를 공부하는 외국인이나 외국어를 공부하는 한국인에게도 도움이 될 것입니다.
		</p>
	</div>
);

let root;

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const SelectedHeader = props => {
	if (props.isSwitch) {
		root.state[props.name] = true;
	}
	return (
		<Card
			size="small"
			style={{ background: '#596674', borderRadius: 0, border: 0 }}
			bodyStyle={{ padding: 0, margin: 0 }}
			headStyle={{ borderBottom: 0 }}
			title={
				<Row type="flex" justify="space-between" align="middle" style={{ padding: '1px', margin: '0px' }}>
					<Col span={11}>
						<Row type="flex" justify="start">
							<Col span={6}>
								<Icon type="minus-circle" theme="filled" style={{ fontSize: '16px', color: '#fff' }} />
							</Col>
							<Col style={{ padding: '0px' }} span={10}>
								<span style={{ fontWeight: '500', color: '#fff' }}>
									{props.title} &nbsp;
									{props.lq == null && (
										<Popover placement="topLeft" title={props.title} content={props.content}>
											<Icon
												type="question-circle"
												theme="filled"
												style={{ fontSize: '16px', color: '#fff' }}
											/>
										</Popover>
									)}
								</span>
								<br />
								<span style={{ fontSize: '8pt', color: 'darkgrey' }}>{props.eng}</span>
							</Col>
						</Row>
					</Col>
					<Col>
						{props.isLoading && <Spin indicator={antIcon} />}
						{!props.isLoading && props.count != null && (
							<Badge count={props.count} style={props.countStyle} />
						)}
						{!props.isLoading && props.lq != null && (
							<span style={{ color: '#fff' }}>
								{props.lq} &nbsp; &nbsp;
								<Popover placement="topLeft" title="문서의 난이도" content={content}>
									<Icon
										type="question-circle"
										theme="filled"
										style={{ fontSize: '16px', color: '#fff' }}
									/>
								</Popover>
							</span>
						)}
					</Col>
				</Row>
			}
		/>
	);
};

const UnSelectedHeader = props => {
	return (
		<Card
			size="small"
			style={{ border: 0 }}
			bodyStyle={{ padding: 0 }}
			title={
				<Row type="flex" justify="space-between" align="middle" style={{ padding: '0px', margin: '0px' }}>
					<Col span={11}>
						<Row type="flex" justify="start">
							<Col span={6}>
								<Icon type="plus-circle" style={{ fontSize: '16px', color: '#08c' }} />
							</Col>
							<Col style={{ padding: '0px' }} span={10}>
								<span style={{ fontWeight: '500' }}>
									{props.title}&nbsp;
									{props.lq == null && (
										<Popover placement="topLeft" title={props.title} content={props.content}>
											<Icon
												type="question-circle"
												theme="filled"
												style={{ fontSize: '16px', color: 'rgb(89, 102, 116)' }}
											/>
										</Popover>
									)}
								</span>
								<br />
								<span style={{ fontSize: '8pt', color: 'darkgrey' }}>{props.eng}</span>
							</Col>
						</Row>
					</Col>
					<Col>
						{/*props.isSwitch && (
							<Row justify="end" align="top">
								<Col>
									<Switch
										size="small"
										checked={root.state[props.name]}
										onClick={(checked, e) => {
											e.stopPropagation();
											root.setState({ [props.name]: checked });
										}}
									/>
								</Col>
							</Row>
							
									)*/}
						<Row justify="end">
							<Col>
								{props.isLoading && <Spin indicator={antIcon} />}
								{!props.isLoading && props.count != null && (
									<Badge size="small" count={props.count} style={props.countStyle} />
								)}
								{!props.isLoading && props.lq != null && (
									<span style={{ color: 'rgb(19, 91, 205)' }}>
										{props.lq} &nbsp; &nbsp;
										<Popover placement="topLeft" title="문서의 난이도" content={content}>
											<Icon
												type="question-circle"
												theme="filled"
												style={{ fontSize: '16px', color: 'rgb(89, 102, 116)' }}
											/>
										</Popover>
									</span>
								)}
							</Col>
						</Row>
					</Col>
				</Row>
			}
		/>
	);
};

const mapDispatchToProps = dispatch => ({
	onDecosView: broken1 => dispatch(actions.onDecosView(broken1)),
	onTaggedText: lqInfos => dispatch(actions.onTaggedText(lqInfos)),
	onChangeBlockKey: blockKeys => dispatch(actions.onChangeBlockKey(blockKeys)),
	onBlockKeyText: (blockTexts, flag) => dispatch(actions.onBlockKeyText(blockTexts, flag)),
	onSpellDeco: decos => dispatch(actions.onSpellDeco(decos)),
	onSynoDeco: synos => dispatch(actions.onSynoDeco(synos)),
	onDialectDeco: dialects => dispatch(actions.onDialectDeco(dialects)),
	onHanjasBind: hanjas => dispatch(actions.onHanjasBind(hanjas)),
	onMultiLang: multilangs => dispatch(actions.onMultiLang(multilangs)),
	onSelectRightMenu: selectMenu => dispatch(actions.onSelectRightMenu(selectMenu)),
	onLQScore: lqscore => dispatch(actions.onLQScore(lqscore)),
});

class RightMenu extends Component {
	fetchLq = async text => {
		const post = await services.postApi(this, '/api/lq/book/analysis', text);
		if (post && post.status === 200) {
			let lqInfos = post.data.results;
			if (lqInfos != null) {
				this.props.onLQScore(lqInfos.lq);
				this.setState({ lq: lqInfos.lq, isLqInfosTextLoading: false });
			}
		}
	};

	fetchSummary = async (block, loading) => {
		const { lqInfosByKey } = this.state;
		if (block.blockText == null || (block.blockText != null && block.blockText.replace('\n', '').trim() === '')) {
			lqInfosByKey[block.blockKey] = null;
			this.setState({ lqInfosByKey, changeLqInfos: loading });
			return;
		}
		const post = await services.postApi(this, '/api/lq/book/analysis', block.blockText);
		if (post && post.status === 200) {
			let lqInfos = post.data.results;
			if (lqInfos != null) {
				lqInfosByKey[block.blockKey] = Object.assign({}, lqInfos, { blockKey: block.blockKey });
				this.setState({ lqInfosByKey, changeLqInfos: loading });
			}
		}
	};

	fetchSummary1 = async block => {
		if (block.blockText == null || (block.blockText != null && block.blockText.replace('\n', '').trim() === '')) {
			return { blockKey: block.blockKey, lqInfos: null };
		}
		const post = await services.postApi(this, '/api/lq/book/analysis', block.blockText);
		if (post && post.status === 200) {
			let lqInfos = post.data.results;
			if (lqInfos != null) {
				return { blockKey: block.blockKey, lqInfos: Object.assign({}, lqInfos, { blockKey: block.blockKey }) };
			}
		}
		return { blockKey: block.blockKey, lqInfos: null };
	};

	fetchSpellCheck = async (block, loading) => {
		const datas = { contents: block.blockText };
		if (block.blockText == null || (block.blockText != null && block.blockText.replace('\n', '').trim() === '')) {
			const { decosByKey } = this.state;
			decosByKey[block.blockKey] = null;
			this.setState({ decosByKey, changeDecos: loading });
			return;
		}
		const results = await services.api(this, '/spell', datas, null);
		if (results && results.status === 200) {
			const spellDatas = results.data.spellDatas;
			const pnuNplSpeller = spellDatas.PnuNlpSpeller;
			const pnuErrorWordList = pnuNplSpeller.PnuErrorWordList;

			//반복체크
			const pnuNoRepeatErrorWord = pnuErrorWordList.filter(a => a._attributes.repeat === 'no');
			const { decosByKey } = this.state;
			const spells = pnuNoRepeatErrorWord
				.filter(i => i.hasOwnProperty('PnuErrorWord'))
				.flatMap(i => i.PnuErrorWord)
				.map(i => {
					let candWord = [];
					const count = parseInt(i.CandWordList._attributes.m_nCount);
					if (count !== 0) {
						count > 1
							? (candWord = i.CandWordList.CandWord.map(w => w._text))
							: candWord.push(i.CandWordList.CandWord._text);
					}

					const helpcate = helperCate.filter(a => a.HELPER === i.Help._cdata);
					return {
						key: i._attributes.nErrorIdx,
						blockKey: block.blockKey,
						start: i._attributes.m_nStart,
						end: i._attributes.m_nEnd,
						orgStr: i.OrgStr._text,
						candWord: candWord,
						nCorrectMethod: i.Help._attributes.nCorrectMethod,
						help: i.Help._cdata,
						helpcate: { ...helpcate[0] },
					};
				})
				.filter(i => i != null);

			decosByKey[block.blockKey] = spells;
			this.setState({ decosByKey, changeDecos: loading });
		}
	};

	fetchSpellCheck1 = async block => {
		const datas = { contents: block.blockText };
		if (block.blockText == null || (block.blockText != null && block.blockText.replace('\n', '').trim() === '')) {
			return { blockKey: block.blockKey, data: null };
		}
		const results = await services.api(this, '/spell', datas, null);
		if (results && results.status === 200) {
			const spellDatas = results.data.spellDatas;
			const pnuNplSpeller = spellDatas.PnuNlpSpeller;
			const pnuErrorWordList = pnuNplSpeller.PnuErrorWordList;

			//반복체크
			const pnuNoRepeatErrorWord = pnuErrorWordList.filter(a => a._attributes.repeat === 'no');
			const spells = pnuNoRepeatErrorWord
				.filter(i => i.hasOwnProperty('PnuErrorWord'))
				.flatMap(i => i.PnuErrorWord)
				.map(i => {
					let candWord = [];
					const count = parseInt(i.CandWordList._attributes.m_nCount);
					if (count !== 0) {
						count > 1
							? (candWord = i.CandWordList.CandWord.map(w => w._text))
							: candWord.push(i.CandWordList.CandWord._text);
					}

					const helpcate = helperCate.filter(a => a.HELPER === i.Help._cdata);
					return {
						key: i._attributes.nErrorIdx,
						blockKey: block.blockKey,
						start: i._attributes.m_nStart,
						end: i._attributes.m_nEnd,
						orgStr: i.OrgStr._text,
						candWord: candWord,
						nCorrectMethod: i.Help._attributes.nCorrectMethod,
						help: i.Help._cdata,
						helpcate: { ...helpcate[0] },
					};
				})
				.filter(i => i != null);

			//decosByKey[block.blockKey] = spells;
			//this.setState({ decosByKey, changeDecos: loading });
			return { blockKey: block.blockKey, data: spells };
		}
		return { blockKey: block.blockKey, data: null };
	};

	fetchSynonym = async (block, filters, loading) => {
		if (block.blockText == null || (block.blockText != null && block.blockText.replace('\n', '').trim() === '')) {
			const { synosByKey } = this.state;
			synosByKey[block.blockKey] = null;
			this.setState({ synosByKey, changeSynos: loading });
			return;
		}
		const { synosByKey } = this.state;
		const post = await services.postApi(this, '/api/sentence/synonym', { text: block.blockText, filters });
		if (post && post.status === 200) {
			if (post.data.results != null) {
				const results = post.data.results.filter(x => x != null);
				const _results = results.map(item => Object.assign({}, item, { blockKey: block.blockKey }));
				synosByKey[block.blockKey] = _results;
				this.setState({ synosByKey, changeSynos: loading });
			}
		}
	};

	fetchSynonym1 = async (block, filters) => {
		if (block.blockText == null || (block.blockText != null && block.blockText.replace('\n', '').trim() === '')) {
			return { blockKey: block.blockKey, data: [] };
		}
		const post = await services.postApi(this, '/api/sentence/synonym', { text: block.blockText, filters });
		if (post && post.status === 200) {
			if (post.data.results != null) {
				const results = post.data.results.filter(x => x != null);
				const _results = results.map(item => Object.assign({}, item, { blockKey: block.blockKey }));
				return { blockKey: block.blockKey, data: _results };
			}
		}
		return { blockKey: block.blockKey, data: [] };
	};

	fetchSynonymFilters = async (block, filters) => {
		if (block.blockText == null || (block.blockText != null && block.blockText.replace('\n', '').trim() === '')) {
			const { synosByKey } = this.state;
			synosByKey[block.blockKey] = null;
			this.setState({ isFiltersChanges: true, synosByKey, changeSynos: true });
			return;
		}
		const { synosByKey } = this.state;
		const post = await services.postApi(this, '/api/sentence/synonym', { text: block.blockText, filters });
		if (post && post.status === 200) {
			if (post.data.results != null) {
				const results = post.data.results.filter(x => x != null);
				const _results = results.map(item => Object.assign({}, item, { blockKey: block.blockKey }));
				synosByKey[block.blockKey] = _results;
				this.setState({ isFiltersChanges: true, synosByKey, changeSynos: true });
			}
		}
	};

	fetchSynonymFilters1 = async (block, filters) => {
		if (block.blockText == null || (block.blockText != null && block.blockText.replace('\n', '').trim() === '')) {
			return null;
		}
		const post = await services.postApi(this, '/api/sentence/synonym', { text: block.blockText, filters });
		if (post && post.status === 200) {
			if (post.data.results != null) {
				const results = post.data.results.filter(x => x != null);
				const _results = results.map(item => Object.assign({}, item, { blockKey: block.blockKey }));
				return _results;
			}
		}
		return null;
	};

	fetchDialect = async (block, loading) => {
		if (block.blockText == null || (block.blockText != null && block.blockText.trim() === '')) {
			const { dialectsByKey } = this.state;
			dialectsByKey[block.blockKey] = null;
			this.setState({ dialectsByKey, changeDialect: loading });
			return;
		}
		const post = await services.postApi(this, '/api/sentence/dialect', block.blockText);
		if (post && post.status === 200) {
			if (post.data.results != null) {
				const results = post.data.results.filter(x => x != null);
				const { dialectsByKey } = this.state;
				dialectsByKey[block.blockKey] = results;
				this.setState({ dialectsByKey, changeDialect: loading });
			}
		}
	};

	fetchDialect1 = async (block, loading) => {
		if (block.blockText == null || (block.blockText != null && block.blockText.trim() === '')) {
			return { blockKey: block.blockKey, data: [] };
		}
		const post = await services.postApi(this, '/api/sentence/dialect', block.blockText);
		if (post && post.status === 200) {
			if (post.data.results != null) {
				const results = post.data.results.filter(x => x != null);
				const _results = results.map(item => Object.assign({}, item, { blockKey: block.blockKey }));
				return { blockKey: block.blockKey, data: _results };
			}
		}
		return { blockKey: block.blockKey, data: [] };
	};

	state = {
		blockKeys: [],
		blockTexts: [],
		decosByKey: [],
		decos: [],
		synos: [],
		synosByKey: [],
		lqInfos: [],
		lqInfosByKey: [],
		changeLqInfos: false,
		changeSpellCheck: false,
		changeDecos: false,
		dialects: [],
		dialectsByKey: [],
		changeDialect: false,
		hanja: [],
		hanjaByKey: [],
		changeHanja: false,
		multilangs: [],
		multiByKey: [],
		changeMultiLang: false,
		multioptions: 0,
		selectMenu: 0,
		filtersChange: false,
		changeText: false,
		lq: 0,
		isLoading: false,
		isChanges: false,
		isFiltersChanges: false,
		fetchLqStatus: false,
		modalVisible: false,
	};

	constructor(props) {
		super(props);

		root = this;

		const USER = JSON.parse(window.sessionStorage.getItem('user'));
		let selectedKey = '';
		if (USER != null) {
			selectedKey = '1';
		}

		this.state = {
			...this.state,
			selectedKey,
			disableItems: props.disableItems,
			lqInfosText: props.lqInfosText,
			selectMenu: props.selectMenu,
			filters: props.filters,
			dialectFilters: props.dialectFilters,
			blockKeys: props.blockKeys,
			blockTexts: props.blockTexts,
			flag: props.flag,
			spellChecked: props.spellChecked,
			synoChecked: props.synoChecked,
			dialectChecked: props.dialectChecked,
			lqChecked: props.lqChecked,
		};
	}

	componentDidMount() {
		this.props.onSelectRightMenu(this.state.selectedKey);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			lqInfosText: nextProps.lqInfosText,
			disableItems: nextProps.disableItems,
			selectMenu: nextProps.selectMenu,
			filters: nextProps.filters,
			dialectFilters: nextProps.dialectFilters,
			blockKeys: nextProps.blockKeys,
			blockTexts: nextProps.blockTexts,
			flag: nextProps.flag,
			spellChecked: nextProps.spellChecked,
			synoChecked: nextProps.synoChecked,
			dialectChecked: nextProps.dialectChecked,
			lqChecked: nextProps.lqChecked,
			user: nextProps.user,
			authenticated: nextProps.authenticated,
		});
	}

	async componentDidUpdate(prevProps, prevState) {
		const {
			lqInfosText,
			disableItems,
			blockTexts,
			blockKeys,
			filters,
			dialectFilters,
			flag,
			spellChecked,
			synoChecked,
			dialectChecked,
			lqChecked,
		} = this.state;

		if (this.state.authenticated !== prevState.authenticated) {
			if (this.state.authenticated) {
				const USER = JSON.parse(window.sessionStorage.getItem('user'));
				if (USER != null) {
					this.setState({ selectedKey: '1' });
				}
			} else {
				this.setState({ selectedKey: '' });
			}
		}

		if (lqInfosText !== prevState.lqInfosText) {
			if (lqInfosText != null && lqInfosText.trim() !== '') {
				//if (this.state.selectMenu === '2' || this.state.selectMenu === '4') {
				//this.fetchSummary(text);
				//}
				this.setState({ isLqInfosTextLoading: true });
				this.fetchLq(this.state.lqInfosText);
				const t = nlp(lqInfosText)
					.ngrams({ max: 3 })
					.data()
					.filter(i => i.count > 1)
					.map(i => {
						return { ...i, normal: i.normal.replace(/#q#/g, ',') };
					});

				//this.fetchSummary(text);
				this.setState({ distinctCount: t.length });
			} else {
				this.props.onTaggedText(null);
				this.props.onChangeBlockKey([]);
				this.props.onBlockKeyText([], false);
				this.props.onSpellDeco([]);
				this.setState({
					lqInfos: [],
					lqInfosByKey: [],
					decos: [],
					synos: [],
					dialects: [],
					hanjas: [],
					multilangs: [],
					count: 0,
					blockKeys: [],
					blockTexts: [],
					decosByKey: [],
					synosByKey: [],
					dialectsByKey: [],
					hanjaByKey: [],
					multiByKey: [],
					distinctCount: 0,
					lq: 0,
					isLqInfosTextLoading: false,
				});
			}
		}

		if (disableItems !== prevState.disableItems) {
			this.setState({ changeDecos: true });
		}

		if (blockKeys !== prevState.blockKeys) {
			this.setState({
				changeLqInfos: true,
				changeDecos: true,
				changeSynos: true,
				changeDialect: true,
			});
		}

		if (filters !== prevState.filters) {
			this.setState({
				changeLqInfos: true,
				changeDecos: true,
				changeSynos: true,
				changeDialect: true,
			});

			/*
			if (blockTexts != null && blockTexts.length > 0) {
				this.setState({ isFilterLoading: true });
			}
			blockTexts.forEach(async (item, i) => {
				await this.fetchSynonymFilters(item, filters);
				if (i === blockTexts.length - 1) {
					this.setState({
						isFilterLoading: false,
					});
				}
			});
			*/
		}

		if (dialectFilters !== prevState.dialectFilters) {
			this.setState({
				changeLqInfos: true,
				changeDecos: true,
				changeSynos: true,
				changeDialect: true,
			});
		}

		if (lqChecked !== prevState.lqChecked) {
			if (lqChecked) {
				this.setState({ isLqInfosLoading: true });
				const _lqInfosByKey = await Promise.all(blockTexts.map(async x => await this.fetchSummary1(x)));
				const { lqInfosByKey } = this.state;
				_lqInfosByKey.forEach(element => {
					lqInfosByKey[element.blockKey] = element.lqInfos;
				});
				this.setState({
					changeLqInfos: true,
					lqInfosByKey,
					isLqInfosLoading: false,
					fetchLqStatus: false,
				});
			}
		}

		if (spellChecked !== prevState.spellChecked) {
			if (spellChecked) {
				this.setState({ isSpellCheckLoading: true });

				const _decosByKey = await Promise.all(blockTexts.map(async x => await this.fetchSpellCheck1(x)));

				const { decosByKey } = this.state;
				_decosByKey.forEach(element => {
					decosByKey[element.blockKey] = element.data;
				});
				this.setState({
					changeDecos: true,
					decosByKey,
					isSpellCheckLoading: false,
				});
			}
		}
		if (synoChecked !== prevState.synoChecked) {
			if (synoChecked) {
				this.setState({ isSynonymLoading: true });

				const _synosByKey = await Promise.all(blockTexts.map(async x => await this.fetchSynonym1(x)));

				const { synosByKey } = this.state;
				_synosByKey.forEach(element => {
					synosByKey[element.blockKey] = element.data;
				});
				this.setState({
					changeSynos: true,
					synosByKey,
					isSynonymLoading: false,
				});
			}
		}

		if (dialectChecked !== prevState.dialectChecked) {
			if (dialectChecked) {
				this.setState({ isDialectLoading: true });
				const _dialectsByKey = await Promise.all(blockTexts.map(async x => await this.fetchDialect1(x)));

				const { dialectsByKey } = this.state;
				_dialectsByKey.forEach(element => {
					dialectsByKey[element.blockKey] = element.data;
				});
				this.setState({
					changeDialect: true,
					dialectsByKey,
					isDialectLoading: false,
				});
			}
		}

		if (blockTexts !== prevState.blockTexts) {
			if (!flag) {
				if (lqChecked) {
					this.setState({ isLqInfosLoading: true });

					const _lqInfosByKey = await Promise.all(blockTexts.map(async x => await this.fetchSummary1(x)));
					const { lqInfosByKey } = this.state;
					_lqInfosByKey.forEach(element => {
						lqInfosByKey[element.blockKey] = element.lqInfos;
					});
					this.setState({
						changeLqInfos: true,
						lqInfosByKey,
						isLqInfosLoading: false,
						fetchLqStatus: false,
					});
				}
				if (spellChecked) {
					this.setState({ isSpellCheckLoading: true });

					const _decosByKey = await Promise.all(blockTexts.map(async x => await this.fetchSpellCheck1(x)));

					const { decosByKey } = this.state;
					_decosByKey.forEach(element => {
						decosByKey[element.blockKey] = element.data;
					});
					this.setState({
						changeDecos: true,
						decosByKey,
						isSpellCheckLoading: false,
					});
				}

				if (synoChecked) {
					this.setState({ isSynonymLoading: true });

					const _synosByKey = await Promise.all(blockTexts.map(async x => await this.fetchSynonym1(x)));

					const { synosByKey } = this.state;
					_synosByKey.forEach(element => {
						synosByKey[element.blockKey] = element.data;
					});
					this.setState({
						changeSynos: true,
						synosByKey,
						isSynonymLoading: false,
					});
				}

				if (dialectChecked) {
					this.setState({ isDialectLoading: true });
					const _dialectsByKey = await Promise.all(blockTexts.map(async x => await this.fetchDialect1(x)));

					const { dialectsByKey } = this.state;
					_dialectsByKey.forEach(element => {
						dialectsByKey[element.blockKey] = element.data;
					});
					this.setState({
						changeDialect: true,
						dialectsByKey,
						isDialectLoading: false,
					});
				}
			}
		}

		/*
		if (this.state.isFiltersChanges) {
			if (this.state.changeSynos) {
				const { blockKeys, synosByKey } = this.state;
				const synos = blockKeys
					.map(key => synosByKey[key.blockKey])
					.filter(x => x != null)
					.flatMap(item => item);

				this.props.onSynoDeco(synos);

				this.setState({ isFiltersChanges: false, synos });
			}
		}*/

		if (this.state.changeDecos) {
			const { decosByKey, blockKeys } = this.state;

			const decos = blockKeys
				.map(key => decosByKey[key.blockKey])
				.filter(x => x != null)
				.flatMap(item => item);

			let __decos = Object.values(decos)
				.map((item, key) => {
					let isExist = disableItems != null && disableItems.indexOf(item.orgStr) !== -1;
					if (!isExist) {
						return item;
					} else {
						return null;
					}
				})
				.filter(i => i != null);

			this.props.onSpellDeco(__decos);
			this.setState({
				changeDecos: false,
				decos: __decos,
				count: __decos.length,
			});
		}

		if (this.state.changeLqInfos) {
			const { lqInfosByKey, blockKeys } = this.state;
			const lqInfos = blockKeys
				.map(key => lqInfosByKey[key.blockKey])
				.filter(x => x != null)
				.flatMap(item => item);
			this.props.onTaggedText(lqInfos);
			this.setState({
				changeLqInfos: false,
				lqInfos: lqInfos,
			});
		}

		if (this.state.changeSynos) {
			const { blockKeys, synosByKey } = this.state;
			const synos = blockKeys
				.map(key => synosByKey[key.blockKey])
				.filter(x => x != null)
				.flatMap(item => item);

			if (filters !== prevState.fitlers) {
				const _synos = synos
					.map(item => {
						let synonyms = [];
						if (filters.level === 1) {
							synonyms = item.synonyms.filter(
								i => i.SYN_LEVEL < item.PYOJAE_LEVEL && i.SYN_LEVEL > 0 && i.SYN_LEVEL < 33
							);
						}
						if (filters.level === 0) {
							synonyms = item.synonyms.filter(
								i => i.SYN_LEVEL > item.PYOJAE_LEVEL && i.SYN_LEVEL > 0 && i.SYN_LEVEL < 33
							);
						}
						if (filters.level === 2) {
							synonyms = item.synonyms;
						}

						if (filters.base1) {
							const pattern = /일상/;
							synonyms = synonyms.filter(i => pattern.test(i.DIC_TAG));
						}

						if (filters.base2) {
							const pattern = /정서/;
							synonyms = synonyms.filter(i => pattern.test(i.DIC_TAG));
						}

						if (filters.base3) {
							const pattern = /학술/;
							synonyms = synonyms.filter(i => pattern.test(i.DIC_TAG));
						}

						if (filters.checkedKeys.length > 0) {
							const tfs = filters.checkedKeys.join('|');
							const pattern = new RegExp(tfs, 'g');
							const pattern2 = /일상/;
							synonyms = synonyms.filter(i => pattern.test(i.TECH_TERM_01) && !pattern2.test(i.DIC_TAG));
						}
						return Object.assign({}, item, { synonyms, count: synonyms.length });
					})
					.filter(x => x.synonyms != null && x.synonyms.length > 0);

				this.props.onSynoDeco(_synos);
				this.setState({ changeSynos: false, synos: _synos });
			} else {
				this.props.onSynoDeco(synos);
				this.setState({ changeSynos: false, synos });
			}
		}

		if (this.state.changeDialect) {
			const { blockKeys, dialectsByKey, dialectFilters } = this.state;
			const _dialects = blockKeys.map(key => dialectsByKey[key.blockKey]).filter(x => x != null);
			const __dialects = [].concat(..._dialects);

			let dialects = __dialects;
			dialects = dialects
				.map(x => {
					return Object.assign({}, x, {
						dialect: x.dialect.map(i => {
							return Object.assign({}, i, {
								LOCATION: i.LOCATION.split(',').map(x => x.trim()),
							});
						}),
					});
				})
				.filter(item => item.dialect.length > 0);

			if (dialectFilters != null && dialectFilters.length > 0) {
				const tfs = dialectFilters.join('|');
				const pattern = new RegExp(tfs, '');
				dialects = dialects.filter(item => {
					const locations = item.dialect.filter(
						x =>
							x.LOCATION.filter(i => pattern.exec(i.trim())) != null &&
							x.LOCATION.filter(i => pattern.exec(i.trim())).length > 0
					);
					return locations.length > 0;
				});
			}

			this.props.onDialectDeco(dialects);
			this.setState({ changeDialect: false, dialects });
		}
	}

	onAccordianChange = key => {
		if (key !== undefined) {
			if (this.props.match.params.board.indexOf('sample') < 0) {
				//const USER = JSON.parse(window.sessionStorage.getItem('user'));
				const user = this.props.user;
				if (user != null) {
					if (user.status === 'valid' && user.item === 'premium') {
						if (key === '10') {
							info();
							this.setState({ selectedKey: key });
							return;
						} else {
							this.props.onSelectRightMenu(key);
							this.setState({ selectedKey: key });
							this.props.history.push({
								pathname: this.props.match.url + '/decos',
								post: {},
							});
							//}
							this.props.onDecosView(true);
							return;
						}
					} else {
						//난이도
						if (user == null && key === '1') {
							message.info('로그인 후 이용 가능합니다.');
							return;
						}
						//맞춤법 외
						if (key !== '1' && key !== '5' && key !== '10') {
							this.showPaymentModal(key);
							return;
						}

						if (key === '10') {
							info();
							this.setState({ selectedKey: key });
							return;
						} else {
							this.props.onSelectRightMenu(key);
							this.setState({ selectedKey: key });
							this.props.history.push({
								pathname: this.props.match.url + '/decos',
								post: {},
							});
							//}
							this.props.onDecosView(true);
							return;
						}
					}
				} else {
					//난이도
					if (key === '1') {
						message.info('로그인 후 이용 가능합니다.');
						return;
					}
					//맞춤법 외
					if (key !== '5' && key !== '10') {
						this.showPaymentModal(key);
						return;
					}
				}
			} else {
				if (key === '10') {
					info();
					this.setState({ selectedKey: key });
					return;
				} else {
					this.props.onSelectRightMenu(key);
					this.setState({ selectedKey: key });
					this.props.history.push({
						pathname: this.props.match.url + '/decos',
						post: {},
					});
					//}
					this.props.onDecosView(true);
					return;
				}
			}
		}
	};

	showPaymentModal = key => {
		let name, url;
		switch (key) {
			case '6':
				name = '유의어 추천';
				url = ['function05_1.jpg', 'function05_2.jpg'];
				break;
			case '3':
				name = '중복 표현';
				url = ['function06_1.jpg'];
				break;
			case '2':
				name = '어휘 통계';
				url = ['function07_1.jpg'];
				break;
			case '7':
				name = '한자';
				url = ['function08_1.jpg'];
				break;
			case '8':
				name = '방언';
				url = ['function09_1.jpg'];
				break;
			case '9':
				name = '다국어';
				url = ['function10_1.jpg'];
				break;
			default:
				name = '';
				url = [];
				break;
		}
		this.setState({
			name,
			url,
			modalVisible: true,
		});
	};

	handleOk = e => {
		window.location.href = '/views/mypage/payment/step1';
		this.setState({
			modalVisible: false,
		});
	};

	handleCancel = e => {
		this.setState({
			modalVisible: false,
		});
	};

	render() {
		const {
			lqInfos,
			decos,
			selectedKey,
			count,
			synos,
			dialects,
			lqInfosText,
			distinctCount,
			lq,
			isLqInfosLoading,
			isFilterLoading,
			isSpellCheckLoading,
			isSynonymLoading,
			isDialectLoading,
			isLqInfosTextLoading,
		} = this.state;

		return (
			<Content>
				<div className={'menucontent'}>
					<Collapse
						bordered={false}
						accordion={true}
						defaultActiveKey={[selectedKey]}
						activeKey={this.state.selectedKey}
						onChange={this.onAccordianChange}
					>
						<Panel
							key="1"
							showArrow={false}
							header={
								selectedKey === '1' ? (
									<SelectedHeader
										title="난이도"
										eng="DIFFICULTY"
										lq={lq}
										isLoading={isLqInfosLoading || isLqInfosTextLoading}
										content={content}
									/>
								) : (
									<UnSelectedHeader
										title="난이도"
										eng="DIFFICULTY"
										lq={lq}
										isLoading={isLqInfosLoading || isLqInfosTextLoading}
										content={content}
									/>
								)
							}
							style={selectedKey === '1' ? customPanelStyle.selected : customPanelStyle.unselected}
						>
							<LiteracyInfo lqInfos={lqInfos} lq={lq} />
						</Panel>
						<Panel
							key="5"
							showArrow={false}
							header={
								selectedKey === '5' ? (
									<SelectedHeader
										title="맞춤법 검사"
										eng="SPELLCHECKER"
										count={count}
										isLoading={isSpellCheckLoading}
										isSwitch={true}
										name="swspellcheck"
										content={content_spell}
									/>
								) : (
									<UnSelectedHeader
										title="맞춤법 검사"
										eng="SPELLCHECKER"
										count={count}
										isLoading={isSpellCheckLoading}
										isSwitch={true}
										name="swspellcheck"
										content={content_spell}
									/>
								)
							}
							style={selectedKey === '5' ? customPanelStyle.selected : customPanelStyle.unselected}
						>
							<SpellsSetup decos={decos} />
						</Panel>
						{/* <Panel
							key="10"
							showArrow={false}
							style={selectedKey === '10' ? customPanelStyle.selected : customPanelStyle.unselected}
							header={
								selectedKey === '10' ? (
									<SelectedHeader
										title={
											<Fragment>
												문법/어법 검사{' '}
												<Tag color="volcano" style={{ fontSize: '10px', lineHeight: '12px' }}>
													BETA
												</Tag>
											</Fragment>
										}
										eng="GRAMMAR CHECKER"
										content={content_grammar}
									/>
								) : (
									<UnSelectedHeader
										title={
											<Fragment>
												문법/어법 검사{' '}
												<Tag color="volcano" style={{ fontSize: '10px', lineHeight: '12px' }}>
													BETA
												</Tag>
											</Fragment>
										}
										eng="GRAMMAR CHECKER"
										content={content_grammar}
									/>
								)
							}
						>
							<Advance />
						</Panel> */}
						<Panel
							key="6"
							showArrow={false}
							header={
								selectedKey === '6' ? (
									<SelectedHeader
										title="유의어 추천"
										eng="THESAURUS"
										count={synos.length}
										countStyle={{ backgroundColor: '#52c41a' }}
										isLoading={isSynonymLoading || isFilterLoading}
										isSwitch={true}
										name="swthesaurus"
										content={content_syn}
									/>
								) : (
									<UnSelectedHeader
										title="유의어 추천"
										eng="THESAURUS"
										count={synos.length}
										countStyle={{ backgroundColor: '#52c41a' }}
										isLoading={isSynonymLoading || isFilterLoading}
										isSwitch={true}
										name="swthesaurus"
										content={content_syn}
									/>
								)
							}
							style={selectedKey === '6' ? customPanelStyle.selected : customPanelStyle.unselected}
						>
							<SynoSetup isLoading={isSynonymLoading || isFilterLoading} />
						</Panel>
						<Panel
							key="3"
							showArrow={false}
							header={
								selectedKey === '3' ? (
									<SelectedHeader
										title="중복 표현"
										eng="DUPLICATE EXPRESSION"
										count={distinctCount}
										countStyle={{ backgroundColor: 'rgb(243, 171, 40)' }}
										isLoading={isLqInfosTextLoading}
										content={content_distinct}
									/>
								) : (
									<UnSelectedHeader
										title="중복 표현"
										eng="DUPLICATE EXPRESSION"
										count={distinctCount}
										countStyle={{ backgroundColor: 'rgb(243, 171, 40)' }}
										isLoading={isLqInfosTextLoading}
										content={content_distinct}
									/>
								)
							}
							style={selectedKey === '3' ? customPanelStyle.selected : customPanelStyle.unselected}
						>
							<DistinctInfo selectedKey={selectedKey} text={lqInfosText} />
						</Panel>
						<Panel
							key="2"
							showArrow={false}
							header={
								selectedKey === '2' ? (
									<SelectedHeader
										title="어휘 통계"
										eng="WORD STATISTICS"
										isLoading={isLqInfosTextLoading}
										content={content_word}
									/>
								) : (
									<UnSelectedHeader
										title="어휘 통계"
										eng="WORD STATISTICS"
										isLoading={isLqInfosTextLoading}
										content={content_word}
									/>
								)
							}
							style={selectedKey === '2' ? customPanelStyle.selected : customPanelStyle.unselected}
						>
							<WordInfo lqInfos={lqInfos} />
						</Panel>
						<Panel
							key="7"
							showArrow={false}
							header={
								selectedKey === '7' ? (
									<SelectedHeader title="한자" eng="漢字" content={content_hanja} />
								) : (
									<UnSelectedHeader title="한자" eng="漢字" content={content_hanja} />
								)
							}
							style={selectedKey === '7' ? customPanelStyle.selected : customPanelStyle.unselected}
						>
							<HanjaSetup />
						</Panel>
						<Panel
							key="8"
							showArrow={false}
							header={
								selectedKey === '8' ? (
									<SelectedHeader
										title="방언"
										eng="KOREAN DIALECTS"
										count={dialects.length}
										countStyle={{ backgroundColor: '#52c41a' }}
										isLoading={isDialectLoading}
										isSwitch={true}
										name="swdialects"
										content={content_dialect}
									/>
								) : (
									<UnSelectedHeader
										title="방언"
										eng="KOREAN DIALECTS"
										count={dialects.length}
										countStyle={{ backgroundColor: '#52c41a' }}
										isLoading={isDialectLoading}
										isSwitch={true}
										name="swdialects"
										content={content_dialect}
									/>
								)
							}
							style={selectedKey === '8' ? customPanelStyle.selected : customPanelStyle.unselected}
						>
							<DialectSetup />
						</Panel>
						<Panel
							key="9"
							showArrow={false}
							header={
								selectedKey === '9' ? (
									<SelectedHeader title="다국어" eng="MULTILINGUAL" content={content_multi} />
								) : (
									<UnSelectedHeader title="다국어" eng="MULTILINGUAL" content={content_multi} />
								)
							}
							style={selectedKey === '9' ? customPanelStyle.selected : customPanelStyle.unselected}
						>
							<MultiLangSetup />
						</Panel>
					</Collapse>
				</div>
				<Modal
					title="문장검사 서비스입니다."
					visible={this.state.modalVisible}
					onOk={this.handleOk}
					onCancel={this.handleCancel}
					okText="예"
					width={'70%'}
					centered
					cancelText="아니오"
					bodyStyle={{ backgroundColor: '#4b4848', color: 'white' }}
					footer={null}
				>
					<div>
						<p>선택하신 {this.state.name} 서비스는 문장검사 서비스입니다.</p>
						<p>서비스 사용을 위해 결제하시겠습니까?</p>
						<p>
							<Button type="primary" onClick={this.handleOk}>
								예
							</Button>{' '}
							<Button onClick={this.handleCancel}>아니오</Button>
						</p>
						<Carousel autoplay>
							{this.state.url &&
								this.state.url.map(x => (
									<div key={x}>
										<img src={'/assets/imgs/sentence/' + x} alt={this.state.name} width={'100%'} />
									</div>
								))}
						</Carousel>
					</div>
				</Modal>
			</Content>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RightMenu));
